import { fromJS } from 'immutable';

export const initialState = fromJS({
    isGroupMembershipAddedToPartner: undefined
});
